var _rect, _path, _path2, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCsv = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 36,
  x: 9,
  y: 2,
  fill: "#EBEBEB",
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C8C8C8",
  d: "M9 29h30v7a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DDD",
  d: "M30 29V2h7a2 2 0 0 1 2 2v25z"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 19.5,
  x: 1,
  y: 11,
  fill: "#EE7623",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.74 22.34q-.06.56-.27 1.03t-.58.82a2.7 2.7 0 0 1-.9.55q-.53.19-1.23.19a3.5 3.5 0 0 1-1.38-.26 2.8 2.8 0 0 1-1.02-.74 3.45 3.45 0 0 1-.63-1.18 5.4 5.4 0 0 1-.21-1.56q0-.88.23-1.58.24-.7.67-1.18.43-.49 1.03-.74.6-.26 1.32-.26.67 0 1.16.17t.83.49q.35.31.55.75.21.44.31.98l-1.19.17a3.6 3.6 0 0 0-.2-.64 1.4 1.4 0 0 0-.32-.47 1.2 1.2 0 0 0-.47-.3 1.8 1.8 0 0 0-.67-.11q-.48 0-.85.19a1.8 1.8 0 0 0-.63.55 2.6 2.6 0 0 0-.38.85 4.4 4.4 0 0 0-.13 1.12q0 .63.13 1.13a2.7 2.7 0 0 0 .4.86q.26.35.62.54.37.18.84.18.42 0 .71-.11.3-.11.5-.31c.2-.2.237-.293.31-.48q.12-.29.17-.65zm2.076.23q.08.7.5 1.02.43.32 1.27.32.41 0 .69-.09t.45-.24a.8.8 0 0 0 .24-.35q.07-.21.07-.44 0-.17-.05-.33a.8.8 0 0 0-.18-.31 1.1 1.1 0 0 0-.35-.24 2 2 0 0 0-.56-.17l-.91-.17a6 6 0 0 1-.96-.25q-.42-.15-.71-.39a1.7 1.7 0 0 1-.43-.6 2.4 2.4 0 0 1-.14-.87q0-.51.2-.89.21-.38.57-.63.36-.26.85-.38a4.3 4.3 0 0 1 1.08-.13q.74 0 1.24.17t.81.45q.31.27.47.63t.22.75l-1.14.18q-.14-.6-.49-.89-.34-.29-1.09-.29-.43 0-.72.08-.28.07-.46.21a.8.8 0 0 0-.25.31.9.9 0 0 0-.07.36q0 .47.25.7.26.23.9.36l.99.19q1.13.21 1.66.72.53.5.53 1.45 0 .45-.17.84a1.8 1.8 0 0 1-.5.67 2.5 2.5 0 0 1-.85.44q-.501.17-1.17.17-1.37 0-2.15-.57-.78-.58-.86-1.79zm6.248-4.96 1.96 5.5 1.99-5.5h1.29l-2.71 7.14h-1.16l-2.72-7.14z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCsv);
export default ForwardRef;